import './index.css'
import React from 'react'
import { getPriorityColor } from '../../utilities/functions';
import { ArrowOutward, LoadingSpinner, WarningIcon, WarningIconRounded } from '../common/Icons';

interface FlashcardPriorityProps {
  name: string;
  counter: number,
  counterNeedUpdate: number,
  prCode: string;
  onClick: () => void;
  onClickNeedUpdate: () => void;
  loading?: boolean;
}

const FlashcardPriority: React.FC<FlashcardPriorityProps> = ({
  name = '',
  counter = 0,
  counterNeedUpdate = 0,
  prCode = '',
  onClick = () => { },
  onClickNeedUpdate = () => { },
  loading = false

}) => {
  return (<article className={`dashboard-flashcard ${loading ? 'loading' : ''}`} style={{ backgroundColor: getPriorityColor(prCode) }}>
    {loading ? <div className='loading-flashcard'></div> : (<>
      <div className='flashcard-title'>
        <p>
          {name}
        </p>
        <button onClick={onClick}>
          <ArrowOutward className='flashcard-arrowoutward' />
        </button>
      </div>

      <div className='flashcard-counter'>
        <p>
          {counter}
        </p>
      </div>

      <div className='flashcard-needupd'>
        <p>
          Necesita Actualización:
          <button
            onClick={onClickNeedUpdate}>{counterNeedUpdate}
          </button>

        </p>
        {counterNeedUpdate > 0 && (
          <div className='pulsing'>
            <WarningIconRounded />
          </div>
        )}
      </div>
    </>)}
  </article>)
}

export default FlashcardPriority;